export const COURTS = ['Court 1', 'Court 2', 'Court 3'];

export const STORAGE_KEYS = {
  bookings: 'badmintonBookings',
  slots: 'badmintonAvailableSlots',
};

export const ADMIN_PASSWORD = 'admin123';

export const ROUTES = {
  landing: '/',
  bookings: '/bookings',
  admin: '/admin',
};

export const BOOKING_VIEW = {
  book: 'book',
  myBookings: 'myBookings',
};
